import * as React from 'react';
import { Avatar, Divider, Grid, Link, List, ListItem, ListItemAvatar, ListItemText, SvgIcon, Typography } from '@material-ui/core';


export class EventSalesTaxAdjustmentNotification extends React.Component<IPortalUserNotificationProps> {

    state = {
        dismissed: false,
    }

    HandleDismissClick = async () => {
        this.props.dismissNotification(this.props.notificationId);
        this.setState({...this.state, dismissed: true});
    }    

    HandleChangePage = async ()=>{
        this.props.changePage(`/event?id=${this.props.entityId}&salestaxsettings=1`);
    }

    render() {
        return (
            <div>
                {!this.state.dismissed && <div>
                    <ListItem alignItems="flex-start">
                        <ListItemAvatar>
                            <Avatar>T</Avatar>
                        </ListItemAvatar>
                        <ListItemText
                            primary={
                                <React.Fragment>
                                    <Link href="#" onClick={this.HandleChangePage}>
                                        {this.props.title}</Link>
                                    <div style={{ float: 'right', fontSize: 'smaller', marginLeft:'5px' }}>
                                        {this.props.createdAt.toDateString()}
                                    </div>
                                </React.Fragment>}
                            secondary={
                                <React.Fragment>
                                    {"You need to check Sales Tax Rate Adjustment"}
                                    <Grid container justify="flex-end">
                                        <Link href="#" onClick={this.HandleDismissClick}>Dismiss</Link>
                                    </Grid>
                                </React.Fragment>
                            }
                        />
                    </ListItem>
                    <Divider variant="inset" component="li" />
                </div>}
            </div>
        );
    }
}